var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoiaNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26351 9.32764H4.88169V3.08764H2.26351C2.14778 3.08764 2.03679 3.13821 1.95496 3.22822C1.87312 3.31824 1.82715 3.44033 1.82715 3.56764V8.84764C1.82715 8.97494 1.87312 9.09703 1.95496 9.18705C2.03679 9.27707 2.14778 9.32764 2.26351 9.32764V9.32764Z",
    stroke: "currentColor",
    strokeWidth: 0.873298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88135 9.32744L7.06317 14.1274C7.52609 14.1274 7.97005 13.9252 8.29739 13.5651C8.62472 13.205 8.80862 12.7167 8.80862 12.2074V10.7674H12.185C12.3087 10.7678 12.4311 10.739 12.5439 10.683C12.6567 10.627 12.7573 10.5451 12.8389 10.4428C12.9206 10.3405 12.9813 10.2201 13.0172 10.0899C13.0531 9.95958 13.0631 9.82237 13.0468 9.68744L12.3923 3.92744C12.3658 3.69621 12.2637 3.48347 12.1052 3.32891C11.9466 3.17435 11.7423 3.08853 11.5304 3.08744H4.88135",
    stroke: "currentColor",
    strokeWidth: 0.873298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoiaNegative);
export default __webpack_public_path__ + "static/media/JoiaNegative.932e763de06a76323918f9f57f356b46.svg";
export { ForwardRef as ReactComponent };